import mapObject from 'underscore/modules/mapObject';
import isUndefined from 'underscore/modules/isUndefined';

export const nullifyUndefinedProperties = obj =>
    mapObject(obj, value => (isUndefined(value) ? null : value));
